import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "spinner", "text"]
  static values = {
    saving: String
  }

  connect() {
    this.originalText = this.textTarget.textContent

    const form = this.element.closest('form')

    if (!form) { return }

    form.addEventListener('direct-uploads:start', () => {
      console.log("direct-upload:start:spinner")
      this.runSpinner()
    })
    form.addEventListener('direct-uploads:end', () => {
      console.log("direct-upload:initialize:spinner")
      this.stopSpinner()
    })
    form.addEventListener('direct-uploads:error', () => {
      console.log("direct-upload:error:spinner")
      this.stopSpinner()
    })
    form.addEventListener('turbo:submit-end', (event) => {
      this.stopSpinner()

      if (event.detail.success) {
        form.reset()
      }
    })
  }

  runSpinner() {
    this.spinnerTarget.classList.remove('hidden')
    this.buttonTarget.disabled = true
    if (this.hasSavingValue) {
      this.textTarget.textContent = this.savingValue
    }
  }

  stopSpinner() {
    this.spinnerTarget.classList.add('hidden')
    this.buttonTarget.disabled = false
    if (this.hasSavingValue) {
      this.textTarget.textContent = this.originalText
    }
  }
}
